import { FAQPage, WithContext } from 'schema-dts';
import MainJsonLD from './main';
import { SchemaIds } from './prepIds';

interface Props {
  faqs: { question: string; answer?: string }[];
  overrideJson?: string;
  title?: string;
  ids: SchemaIds;
}

export function FaqJsonLd({ faqs, overrideJson, title, ids }: Props) {
  if (overrideJson) return <MainJsonLD json={overrideJson} />;

  const { id, orgId } = ids;

  const jsonLd: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: title,
    '@id': id,
    about: orgId
      ? {
          '@id': orgId,
        }
      : undefined,
    mainEntity: faqs.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer || '',
      },
    })),
  };

  return <MainJsonLD jsonLd={jsonLd} />;
}
